const state = {
  info: []
}

const mutations = {
  GET_PAY_INFO(state, info) {
    state.info = info
  }
}

const actions = {
  getPayInfo({commit}, info) {
    commit('GET_PAY_INFO', info)
  }
}

export default {
  state,
  mutations,
  actions
}
